import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Avatar,
  Typography,
  Grid,
  Select,
  MenuItem,
  Divider,
} from '@mui/material';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { API } from '../../../controller/api';
import Cookies from 'js-cookie';
import LoadingModal from './LoadingModal';

const MAX_ENTRY_MESSAGE_CHAR_COUNT = 100;
const MAX_CHAR_COUNT = 10000;

const chatModels = [
    {
    name:'GPT 4.1',
    route:'chat'
   },
   {
    name:'Claude Haiku 4.5',
    route:'claude-chat'
   },
   {
    name:'Gemini 3.5 Flash',
    route:'gemini-chat'
   },
   {
    name:'Grok 4',
    route:'chat-grok'
   },
]

const EditCustomChatAssistantModal = ({ open, handleClose, data, setFormData, update, setUpdate }) => {
    const userId = Cookies.get('userId');
    const [loading, setLoading] = useState(false);
  const handleChangeSingle = (field, value) => {

      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));

  };
  

  const handleChange = (field, value, maxCharCount) => {
    if (value.length <= maxCharCount) {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

 
  const handleNestedChange = (field, value) => {
    // Prevent typing beyond the max character count
    if (value.length <= MAX_CHAR_COUNT) {
      setFormData((prev) => ({
        ...prev,
        initialPrompt: {
          ...prev.initialPrompt,
          [field]: value,
        },
      }));
    }
  };

  const handleSubmit = async () => {
  console.log(data)
  setLoading(true)

  const response = await axios.post(`${API}/custom-bots/update-bot`,{userId, bot:data});

  if(response.data.message === 'Success'){
    setLoading(false)

    window.alert('Your bot has successfully updated.')
    setUpdate(!update)
     handleClose();
  } else {
    setLoading(false)

    window.alert('Something went wrong. Please try again or contact support.')

  }
   
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle><b>Edit Custom Chat Assistant</b></DialogTitle>
      <Divider/>
      <DialogContent>
      <Typography className='mb-3'>Fill the information below to create your owe chat assistant:</Typography>

        <Grid spacing={2} container>
            <Grid item xs={12} sm={6}>
        
        <Typography><b>Chat Assistant Name:</b></Typography>
        <TextField
    
          fullWidth
          margin="dense"
          value={data?.appName}
          onChange={(e) => handleChangeSingle('appName', e.target.value)}
        />
    </Grid>
    <Grid item xs={12} sm={6}>
    <Typography className='mb-2'><b>Choose Chat Model:</b></Typography>

        <Select 
        fullWidth
        onChange={(e)=>handleChangeSingle('route', e.target.value)}
        value={data?.route}
        >
           {chatModels.map((i,index)=>{
            return(<MenuItem key={index} value={i.route}>{i.name}</MenuItem>)
           })}
            
        </Select>
    </Grid>

</Grid>
<Typography><b>Entry Message:</b></Typography>
        <Typography>Write the message you will see when you start a new chat:</Typography>
        <TextField
          placeholder="Entry Message"
          fullWidth
          margin="dense"
          multiline
          minRows={3}
          value={data?.entryMessage}
          onChange={(e) => handleChange('entryMessage', e.target.value, MAX_ENTRY_MESSAGE_CHAR_COUNT)}
          helperText={`${data?.entryMessage.length}/${MAX_ENTRY_MESSAGE_CHAR_COUNT}`}
          FormHelperTextProps={{
            sx: { textAlign: 'right', width: '100%', paddingRight:2  },
          }}
        />

<Typography><b>Assistant Details:</b></Typography>
        <Typography>Detail what you would like your assistant to help you with:</Typography>
        <TextField
          placeholder="Assistant Details"
          fullWidth
          margin="dense"
          multiline
          minRows={3}
          value={data?.initialPrompt.content}
          onChange={(e) => handleNestedChange('content', e.target.value)}
          helperText={`${data?.initialPrompt.content.length}/${MAX_CHAR_COUNT}`}
          FormHelperTextProps={{
            sx: { textAlign: 'right', width: '100%', paddingRight:2 },
          }}
        />
      </DialogContent>
      <DialogActions sx={{padding:3}}>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained">
          <b>Update Assistant</b>
        </Button>
      </DialogActions>
      <LoadingModal 
      Open={loading}
      Title="Updating Assistant"
      />
    </Dialog>
  );
};

export default EditCustomChatAssistantModal;
